// extracted by mini-css-extract-plugin
module.exports = {"uniBlue":"#00adef","controls":"controls-module--controls--2iVb4","controls__button":"controls-module--controls__button--34dg8"};